// components/CellWrapper.jsx
const CellWrapper = ({ children, style = {} }) => {
  return (
    <div
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      style={{
        position: "relative",
        zIndex: 1,
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default CellWrapper;
